module.exports = __webpack_public_path__ + "static/media/AutomationTestingProcess-1.9f0f13ca.png";